import {message} from "antd";
import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import FormContent from "./content/FormContent";
import {setHeader} from "../../../../../redux/actions/layout/interaction/action";
import {useDispatch} from "react-redux";
import {t} from "i18next";

const LeaveSettingForm = (props) => {
    const {id} = useParams()
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setHeader(t("tnp.components.timekeeping.text67"), null))
    }, [])

    const scrollToFirstError = (errorFields) => {
        message.error(errorFields[0]?.errors[0]).then(r => r);
        if (errorFields[0]?.name[0] === "email") {
            document.getElementById("contact--link").click();
        } else {
            document.getElementById("basic--link").click();
        }
    };

    return (
        <div
            style={{
                background: "#fff",
                borderRight: "1px solid #EAECF0",
                borderLeft: "1px solid #EAECF0",
                borderTop: "1px solid #EAECF0",
                height: "100%",
                overflow: "hidden",
            }}
        >
            <FormContent
                id={id}
                idGeneral="general"
                idSeniority="seniority"
                idOther="other"
                scrollToFirstError={scrollToFirstError}
            />
        </div>
    );
};

export default LeaveSettingForm;
